import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import cx from "classnames";
import messages from '../../locale/messages';
import withStyles from 'isomorphic-style-loader/withStyles';
import { AngleLeftArrowIcon } from '../Common/Assets/SVGIcon/CommonSvgIcon';
import { ElementsConsumer } from '@stripe/react-stripe-js';
import CardForm from '../CardForm/CardForm';
import Link from '../Link/Link';
import bt from "../../components/commonStyle.css";
import s from "./AddCardForm.css"
import history from '../../history';


function AddCardForm(props) {
  const intl = useIntl()
  const { orderId, bookingId } = props;

  const handleClick = () => {
    orderId
      ? history.push(`/order/${orderId}`)
      : (bookingId
        ? history.push(`/tracking/${bookingId}`)
        : history.push('/payment-method'));
  }

  return (
    <div className={s.addCardWrapper}>
      <div className={s.addCardSectionTitle}><FormattedMessage {...messages.addCard} />
        <div onClick={handleClick} className={cx(bt.customLink, 'customLinkRtl')}><AngleLeftArrowIcon /> {intl.formatMessage(messages.goBack)}</div>
      </div>
      <ElementsConsumer>
        {({ stripe, elements }) => <CardForm stripe={stripe} elements={elements} isPaymentId={2} orderId={orderId} bookingId={bookingId} paymentMethodLoading={false} />}
      </ElementsConsumer>
    </div>
  )
}
export default withStyles(bt, s)(AddCardForm);